// extracted by mini-css-extract-plugin
export default {"grouped-select-filters":"ManageOrders_grouped-select-filters__MmLuv"};